(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/prescript.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/prescript.js');
'use strict';

svs.arena = svs.arena || {};
svs.arena.store = svs.arena.store || {};
svs.arena.helpers = svs.arena.helpers || {};
svs.arena.service = svs.arena.service || {};
svs.arena.shared = svs.arena.shared || {};
svs.arena.shared.hooks = svs.arena.shared.hooks || {};
svs.arena.shared.deposit = svs.arena.shared.deposit || {};
svs.arena.shared.components = svs.arena.shared.components || {};
svs.arena.shared.components.widgetFallbacks = svs.arena.shared.components.widgetFallbacks || {};

svs.arena.pages = svs.arena.pages || {};
svs.arena.pages.invite = svs.arena.pages.invite || {};
svs.arena.pages.teams = svs.arena.pages.teams || {};
svs.arena.pages.teams.teamMembers = svs.arena.pages.teams.teamMembers || {};
svs.arena.pages.teams.components = svs.arena.pages.teams.components || {};

svs.arena.logger = new svs.core.log.Logger('module:arena');


 })(window);